export enum GradeLevel {
  PreSchool = "pre_school",
  PreK = "pre_k",
  Kindergarten = "kindergarten",
  First = "first",
  Second = "second",
  Third = "third",
  Fourth = "fourth",
  Fifth = "fifth",
  Sixth = "sixth",
  Seventh = "seventh",
  Eighth = "eighth",
  Ninth = "ninth",
  Tenth = "tenth",
  Eleventh = "eleventh",
  Twelfth = "twelfth"
}

export const GradeLevelLabels: Record<GradeLevel, string> = {
  [GradeLevel.PreSchool]: "Pre-School",
  [GradeLevel.PreK]: "Pre-K",
  [GradeLevel.Kindergarten]: "Kindergarten",
  [GradeLevel.First]: "1st Grade",
  [GradeLevel.Second]: "2nd Grade",
  [GradeLevel.Third]: "3rd Grade",
  [GradeLevel.Fourth]: "4th Grade",
  [GradeLevel.Fifth]: "5th Grade",
  [GradeLevel.Sixth]: "6th Grade",
  [GradeLevel.Seventh]: "7th Grade",
  [GradeLevel.Eighth]: "8th Grade",
  [GradeLevel.Ninth]: "9th Grade",
  [GradeLevel.Tenth]: "10th Grade",
  [GradeLevel.Eleventh]: "11th Grade",
  [GradeLevel.Twelfth]: "12th Grade"
};